/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */
//jQuery('.shopify-section-group-header-group .social-icons a[aria-label="Discord"]').attr('aria-label','mymagiccurtain.com');
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.shopify-section-group-header-group .social-icons a[aria-label="Discord"]').forEach(element => {
        element.setAttribute('aria-label', 'mymagiccurtain.com');
        element.setAttribute('data-bs-original-title', 'mymagiccurtain.com');
    });
});